import {
  Card,
  CardContent,
  CardHeader,
} from "@/components/ui/card"
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/alert"
import { AlertCircleIcon } from "lucide-react";

const BadReferrer = () => {
  return (
    <>
    <div className='flex flex-col justify-center my-auto min-h-screen'>
        <Card className='sm:max-w-md w-full mx-auto sm:min-h-min min-h-screen sm:rounded-xl rounded-none'>        
          <CardHeader>
            <div className="flex justify-between">
              <div className="mx-auto">
                <img
                  className="dark:hidden h-12 text-center block"
                  src={"/images/black-logo.png"}
                  alt="Collectr"
                />
                <img
                  className="hidden h-12 text-center dark:block"
                  src={"/images/white-logo.png"}
                  alt="Collectr"
                />

              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="flex flex-col justify-center space-y-3">
              <h1 className="text-2xl font-bold text-center">Something went wrong</h1>
              
              <p className="text-sm text-center text-muted-foreground">
                Please disable any VPN or Adblocker you may have and try again. Additionally, please make sure your browser is up-to-date.
              </p>

              <Alert variant="default" className="[&>svg]:size-5 border-destructive">
                <AlertCircleIcon className="stroke-destructive" />   
                <AlertTitle className="text-destructive">Does this keep happening?</AlertTitle>
                <AlertDescription className="flex flex-row items-center">
                  <span className="text-destructive">
                    Please contact us at{" "}
                    <a className="underline" href='mailto:contact@getcollectr.com'>
                      contact@getcollectr.com
                    </a>
                  </span>
                </AlertDescription>
              </Alert>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default BadReferrer;
